import styled from 'styled-components';

const ScreenSection = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ScreenSection;
